import { MixedSchedule, RawSchedule } from '@mode/shared/schedules/contract';
import { toMixedSchedule } from './to-mixed-schedule';

export class ReportDetailsScheduleFacade {
  public schedules: MixedSchedule[] = [];

  public loadRawSchedulesViewDetails(rawSchedules: RawSchedule[]) {
    this.schedules = rawSchedules.map((x) => {
      return this.updateCronIfWeekday(toMixedSchedule(x));
    });
  }

  public cleanUpFrequencyText(rawSchedule: RawSchedule) {
    rawSchedule = toMixedSchedule(rawSchedule);
  }

  private updateCronIfWeekday(mixedSchedule: MixedSchedule) {
    if (mixedSchedule.isWeekday) {
      mixedSchedule.cron.freq = 'weekly';
      mixedSchedule.cron.day_of_week = '1,2,3,4,5';
      mixedSchedule.cron.day_of_month = 1;
    }

    return mixedSchedule;
  }
}
